// extracted by mini-css-extract-plugin
export default {"container":"AboutApp_container__5nokI","sectionTitle":"AboutApp_sectionTitle__cIlZC","titleText":"AboutApp_titleText__3FA-S"};